/*
 * @Author: cc
 * @LastEditTime: 2025-02-18 16:46:58
 */
import { useEffect, useState } from "react";
import classNames from "classnames";
import "./_style.scss";
import logo from "../../img/logo_header.png";
import doctorAssLogo from "../../img/doctorAssLogo.png";
import { connect, useSelector } from "react-redux";
import { UserProps } from "../../reducers/video";
import { HistoryPush, getCookie, useQuery } from "../../common/utils";
import { post } from "../../common/fetch";
import { Dropdown, Menu, Button } from "antd";
import { OrganProps } from "../../actions/index";
import { DownOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import ActivityEntry from "./components/ActivityEntry";
const Header: React.FC = (props: any) => {
  let path: any = useLocation();
  const query = useQuery();
  const projectId = query.get("projectId");
  const history = HistoryPush();
  const [instituteRoleInfo, setInstituteInfo] = useState<any>({
    currentInstituteName: "",
    currentInstituteId: "",
    instituteRoleList: [],
  });
  interface ProjectInfoProps {
    showLogoFlag?: number; // 是否显示logo标识
    showIndexUrlFlag?: number; // 是否显示首页链接标识 
    showPersonCenterFlag?: number; // 是否显示个人中心标识
    projectAllPathLogo: any; // 项目全路径logo
  }
  const projectInfo = useSelector((state: any): ProjectInfoProps => state.projectInfo);
  const cnames = classNames("mvw-header");
  const [sid, setSid] = useState<string | null>(() => getCookie("X-MVW-userID"));
  const isHome = path.pathname === "/" || path.pathname === "/train";
  const hasProjectPageSettings = [
    "/projectInfo",
    "/topicInfo",
    "/classList",
    "/dataQuery",
    "/certificateRecords",
    "/cePayProjectInfo",
  ].includes(path.pathname);
  useEffect(() => {
    if (sid) return;
    const timer = window.setInterval(() => {
      const currentSid = getCookie("X-MVW-userID");
      if (currentSid) setSid(currentSid);
    }, 500);
    return () => window.clearInterval(timer);
  }, [sid]);
  const upDateOrgan = (currentInstituteId: string) => {
    post(
      `/user/front/changeCurrentInstitute`,
      { currentInstituteId },
      true
    ).then((res) => {
      if (res?.code === 0 || res?.code === 200 || res?.code === 2000) {
        window.location.reload();
      }
    }).catch(() => undefined);
  };
  const loginOutMenu = (
    <Menu>
      <Menu.Item>
        <a
          rel="noopener noreferrer"
          onClick={() => {
            history.push("/personal");
          }}
        >
          个人中心
        </a>
      </Menu.Item>
      {/* <Menu.Item>
        <a rel="noopener noreferrer" onClick={loginOut}>
          退出
        </a>
      </Menu.Item> */}
    </Menu>
  );
  useEffect(() => {
    if (!isHome || !sid) return;
    let active = true;
    let retryTimer: number | undefined;
    const loadInstitutes = (attempt = 0) => {
      post(`/shop/front/userInstituteList`, {}, true)
        .then((res) => {
          if (!active) return;
          if (![0, 200, 2000].includes(res?.code) || !res?.data) {
            if (![81, 101].includes(res?.code) && attempt < 2) {
              retryTimer = window.setTimeout(() => loadInstitutes(attempt + 1), 1500);
            }
            return;
          }
          const { data } = res;
          const instituteRoleList = (data.instituteRoleList || []).map(
            (item: { instituteName: string; instituteId: string }) => ({
              label: item.instituteName,
              value: item.instituteId,
            })
          );
          const organData = {
            currentInstituteName: data.currentInstituteName,
            currentInstituteId: data.currentInstituteId,
            instituteRoleList,
          };
          setInstituteInfo(organData);
          props.updateOrganInfo({ type: "SET_ORGAN_INFO", ...organData });
        })
        .catch(() => {
          if (active && attempt < 2) {
            retryTimer = window.setTimeout(() => loadInstitutes(attempt + 1), 1500);
          }
        });
    };
    loadInstitutes();
    return () => {
      active = false;
      if (retryTimer !== undefined) window.clearTimeout(retryTimer);
    };
  }, [isHome, sid]); // eslint-disable-line react-hooks/exhaustive-deps
  const jumpPerson = () => {
    history.push("/personal");
  };
  const pathArray = [
    "/login",
    "/play",
    "/comments",
    "/register",
    "/platfromplay",
    "/cePlatfromplay",
    "/modifyPassWord",
  ];
  return (
    <>
      {/* {(path.pathname  === '/' || path.pathname  === '/train') && <img src={happyNewYear} alt="" style={{width:"100%"}}  onClick={()=>{
        const url = "http://qt.mvwchina.com/vj/r4ag1gh.aspx"
          window.location.href = url;
      }}/>} */}
      {!pathArray.includes(path.pathname) && (
        <div className="header-box">
          <div className={cnames}>
            <div
              className="logo_box"
              onClick={() => {
                history.push("/train");
              }}
            >
              {projectInfo.showLogoFlag === 1 && (
                <div>
                  {projectId === "1345" ? (
                    <img src={doctorAssLogo} alt="" width={"240px"} />
                  ) : (
                    <img
                      src={
                        projectInfo.projectAllPathLogo
                          ? projectInfo.projectAllPathLogo
                          : logo
                      }
                      alt=""
                    />
                  )}
                </div>
              )}
              {sid && <ActivityEntry />}
            </div>
            <div style={{ display: "flex" }}>
              {sid &&
                isHome &&
                (instituteRoleInfo.instituteRoleList.length > 0 || instituteRoleInfo.currentInstituteName) && (
                  <div className="mechanism_box">
                    {instituteRoleInfo.instituteRoleList.length > 0 ? <Dropdown
                      overlay={
                        <Menu>
                          {instituteRoleInfo.instituteRoleList.map(
                            (item: any, index: number) => (
                              <Menu.Item key={index}>
                                <a
                                  rel="noopener noreferrer"
                                  style={{
                                    color:
                                      item.value ===
                                      instituteRoleInfo.currentInstituteId
                                        ? "blue"
                                        : "",
                                  }}
                                  onClick={() => {
                                    upDateOrgan(item.value);
                                  }}
                                >
                                  {item.label}
                                </a>
                              </Menu.Item>
                            )
                          )}
                        </Menu>
                      }
                      placement="bottomLeft"
                      arrow
                    >
                      <div>
                        <span>机构选择：</span>
                        <span style={{ fontSize: "14px" }}>
                          {instituteRoleInfo.currentInstituteName}
                        </span>
                        <DownOutlined
                          style={{ fontSize: "12px", marginLeft: "6px" }}
                        />
                      </div>
                    </Dropdown> : <span>机构选择：{instituteRoleInfo.currentInstituteName}</span>}
                  </div>
                )}
              {sid &&
                path.pathname !== "/modifyPassWord" && path.pathname !== "/error" &&
                (!hasProjectPageSettings || projectInfo.showPersonCenterFlag !== 0) && (
                  <div
                    className="user_center"
                    onClick={() => {
                      jumpPerson();
                    }}
                  >
                    <span style={{ fontSize: "14px" }}>个人中心</span>
                  </div>
                )}
              {!sid && path.pathname !== "/modifyPassWord" && (
                <Button
                  onClick={() => {
                    history.push("/login");
                  }}
                  type="primary"
                >
                  登录
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
const upDateUserInfo = (dispatch: any) => {
  return {
    upDateUserInfo: (param: UserProps) => {
      dispatch({ ...param });
    },
    updateOrganInfo: (param: OrganProps) => {
      dispatch({ ...param });
    },
  };
};
const getNavStatus = (state: {
  navOptions: { show: boolean };
  userInfo: UserProps;
  organInfo: OrganProps;
}) => {
  return {
    navOptions: state.navOptions,
    userInfo: state.userInfo,
  };
};
export default connect(getNavStatus, upDateUserInfo)(Header);
